import { useCallback, useState } from "react"
import { getAllTicketByAddress } from "services/ticketServices"
import { useAccount } from "wagmi"

const useTickets = () => {
    const { address } = useAccount()
    const [ticketList, setTicketList] = useState<any>([])
    const [filter, setFilter] = useState('')

    const getTicketList = useCallback(async () => {
        if(!address || !filter) return
        const params = {
            address: address as `0x${string}`,
            filter: filter
          }
        const result = await getAllTicketByAddress(params)
        setTicketList(result)
    }, [address, filter])

    const updateFilter = useCallback((val: string) => {
        setFilter(val)
    }, [])

    return { ticketList, updateFilter, getTicketList }
}

export default useTickets